import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';

import {ArticlePageLayout} from '../../../components/DataDisplay';
import {WarningIcon} from '../../../components/Icons';
import {PopupFullPage} from '../../../components/Popup';
import * as localizationKeys from '../../../consts/localization/localizationKeys';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import analyticsService from '../../../services/analyticsService';
import hidReconnectHandlerService from '../../../services/hid/hidReconnectHandlerService';
import iqosHidService from '../../../services/hid/iqosHidService';
import iotService from '../../../services/iot/iotService';
import {getLocalizedStrings} from '../../../services/localization/localizationService';
import modalService from '../../../services/modalService';
import pairingService from '../../../services/pairingService';
import {selectIotDeviceType} from '../../../state/selectors/iotDevice';

const HidReconnectPopupTemplate = (props) => {
    const {modalType, descriptionKey, showReconnectModalOnError, onCustomClose} = props;
    const localizedStrings = getLocalizedStrings();
    const deviceType = useSelector(selectIotDeviceType);
    const closePopup = () => modalService.hideModal(modalType);
    const onClose = () => {
        closePopup();
        if (onCustomClose) {
            onCustomClose();
        }
    };
    const onClick = async () => {
        closePopup();
        try {
            await iqosHidService.connect({
                onConnect: async () => {
                    try {
                        await iotService.initIotService({isReconnect: true});
                        closePopup();
                    } catch (e) {
                        pairingService.disconnectAndShowCriticalGuide();
                    }
                },
            });
            // eslint-disable-next-line no-empty
        } catch (e) {
            if (showReconnectModalOnError) {
                hidReconnectHandlerService.showHidReconnectModal();
            }
        }
    };

    useEffect(() => {
        analyticsService.pushUsbReconnectionEvent(deviceType);
    }, []);

    useDocumentTitle(localizedStrings[localizationKeys.ACCESSIBILITY_USB_RECONNECT_POPUP_TITLE]);

    return (
        <PopupFullPage
            contentLabel={localizedStrings[localizationKeys.USB_RECONNECT_POPUP_TITLE_TEXT]}
            isCloseVisible
            onClose={onClose}
            closeButtonAriaLabel={localizedStrings[localizationKeys.CLOSE_NOTIFICATION_ARIA_LABEL]}
        >
            <ArticlePageLayout
                icon={<WarningIcon className='mb-4 h-6 w-6 lg:mb-6 lg:h-8 lg:w-8' />}
                descriptionKey={descriptionKey}
                titleKey={localizationKeys.USB_RECONNECT_POPUP_TITLE_TEXT}
                buttonsDirection='column'
                buttonPrimary={{
                    isConnectionTrack: true,
                    onClick,
                    textKey: localizationKeys.USB_POPUP_BTN_RECONNECT,
                }}
                buttonSecondary={{
                    onClick: onClose,
                    textKey: localizationKeys.USB_POPUP_BTN_RECONNECT_SKIP,
                }}
            />
        </PopupFullPage>
    );
};

export default HidReconnectPopupTemplate;
